import { Link } from "react-router-dom"

const Button = ({children, className, href, onClick, disabled = false, loading = false, type = 'button'}) => {
  const isDisabled = disabled || loading;
  
  const buttonContent = loading ? (
    <div className="flex items-center justify-center">
      <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
    </div>
  ) : children;

  return (
    href ? (
      <Link 
        to={href} 
        className={`${className} text-center flex items-center justify-center ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`} 
        onClick={onClick}
      >
        <button 
          className={`${disabled ? 'opacity-50 cursor-not-allowed' : ''}`} 
          type={type} 
          disabled={disabled}
        >
          {children}
        </button>
      </Link>
    ) : (
      <button 
        className={`${className} ${isDisabled ? 'opacity-50 cursor-not-allowed' : ''}`} 
        onClick={onClick}
        type={type}
        disabled={isDisabled}
      >
        {buttonContent}
      </button>
    )
  )
}

export default Button